import { DotLoading, List, Modal, Popup, Tag } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import { momentDate, timeTableDayFromNumber, siteUrl } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Image } from "antd";
const CircularDetails = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  let params = useParams();
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    setDataList([]);
    const form = new FormData();
    form.append("id", params.id);
    form.append("uuid", context.user.uuid);
    form.append("type", "circular");
    form.append("from", "staff");
    axios.post(ServiceUrl.MOB.NOTIFICATION_DETAIL, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      } else {
      }
      setLoader(false);
    });
  };

  const linkClick = (toUrl) => {
    navigate(toUrl);
  };
  function getFileExtension(filename) {
    // get file extension
    const extension = filename.substring(
      filename.lastIndexOf(".") + 1,
      filename.length
    );
    return extension;
  }
  let fileext = "";
  if (dataList.notification_attachment) {
    fileext = getFileExtension(
      siteUrl + "files_list/" + dataList.notification_attachment
    );
  }
  return (
    <>
      <Header
        backAction={true}
        title="Circular Details"
        onBack={(e) => navigate("/staff/app/circular")}
      />
      <div className="page-content-wrapper">
        <div className="container py-3">
          <section className="top-space pt-0 pb-0">
            <div class="chat-list">
              <div class="chat-box">
                <div class="chat-details">
                  <div class="text-head">
                    <h4>{dataList.notification_title}</h4>
                    <p class="time unread">
                      {momentDate(dataList.created_on, "DD-MM-YYYY H:MM")}
                    </p>
                  </div>
                  <div class="text-message" style={{ float: "right" }}>
                    {dataList.notification_attachment ? (
                      <>
                        <a
                          href={
                            siteUrl +
                            "files_list/" +
                            dataList.notification_attachment
                          }
                          target="__blank"
                          download
                        >
                          {" "}
                          <Button
                            type="submit"
                            className="btn-warning btn-lg"
                            style={{ backgroundColor: "#ffca2c" }}
                          >
                            Download <i class="fa fa-download fs-6"></i>
                          </Button>
                        </a>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="chat-list">
                <div class="text-message" style={{ padding: " 10px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: dataList.notification_content,
                    }}
                  />
                </div>
                {dataList.notification_attachment ? (
                  <>
                    {fileext == "jpeg" ||
                    fileext == "png" ||
                    fileext == "jpg" ||
                    fileext == "JPEG" ||
                    fileext == "JPG" ||
                    fileext == "PNG" ? (
                      <Image
                        src={
                          siteUrl +
                          "files_list/" +
                          dataList.notification_attachment
                        }
                        style={
                          props.style || {
                            //  width: "100%",
                            cursor: "pointer",
                            // height: "50px",
                          }
                        }
                        className="bg-white shadow-sm p-2"
                      />
                    ) : (
                      <DocViewer
                        documents={[
                          {
                            uri:
                              siteUrl +
                              "files_list/" +
                              dataList.notification_attachment,
                          }, // Remote file
                        ]}
                        pluginRenderers={DocViewerRenderers}
                      />
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </section>
          <section className="top-space "></section>
        </div>
      </div>
    </>
  );
};
export default CircularDetails;
